// extracted by mini-css-extract-plugin
module.exports = {"videosWrapper":"TopVideos-module--videosWrapper--2IzZ5"};